import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function GoogleCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, "");
    const sid = new URLSearchParams(hash).get("session_id");
    if (!sid) { nav("/auth"); return; }
    (async () => {
      try {
        const consent = localStorage.getItem("harf_oauth_legal_consent") === "accepted";
        const { data } = await api.post("/auth/google", {
          session_id: sid,
          terms_accepted: consent,
          privacy_acknowledged: consent,
          affiliate_code: localStorage.getItem("harf_oauth_affiliate_code") || undefined,
        });
        localStorage.removeItem("harf_oauth_legal_consent");
        localStorage.removeItem("harf_oauth_affiliate_code");
        setToken(data.token);
        setUser(data);
        nav(data.onboarded ? "/dashboard" : "/onboarding");
      } catch {
        toast.error("Connexion Google échouée.");
        nav("/auth");
      }
    })();
  }, []);
  return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Connexion en cours…</div>;
}
